import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2 round 3: rewritten for Project Explore from the real UI, English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Managing Notifications",
    intro: "See your notifications and choose which ones you get.",
    ordered: false,
    steps: [
      "The bell icon at the top of the page shows your notifications. A red number shows how many are unread.",
      "In the bell menu you can choose Mark all as read, or View all notifications to open the Notifications page.",
      "On the Notifications page you can show all notifications or only the unread ones.",
      "Teachers: in the teacher dashboard, choose Settings. Under Notification Preferences, turn Assignment Submissions on or off to choose whether you are notified when students submit assignments. Then choose Save Settings.",
    ],
  },
  es: {
    title: "Cómo manejar las notificaciones",
    intro: "Mira tus notificaciones y elige cuáles quieres recibir.",
    ordered: false,
    steps: [
      "La campana arriba en la página muestra tus notificaciones. Un número rojo indica cuántas no has leído.",
      "En el menú de la campana puedes marcar todas como leídas o ver todas las notificaciones en la página de notificaciones.",
      "En la página de notificaciones puedes ver todas o solo las que no has leído.",
      "Maestros: en el panel de maestro, elige Configuración. En Preferencias de notificaciones, activa o desactiva Entregas de tareas para elegir si quieres un aviso cuando tus estudiantes entreguen una tarea. Luego elige Guardar configuración.",
    ],
  },
};

export default function ManagingNotifications() {
  return <HelpArticle text={TEXT} />;
}
